module.exports = __webpack_public_path__ + "img/iMac@2x.d5faf702.png";